import {useSelector} from "react-redux";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {styled} from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableCell from "@mui/material/TableCell";
import * as React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import {useEffect, useState} from "react";
import Api, {postApi} from "../Api";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import {DeleteOutline} from "@mui/icons-material";
import Button from "@mui/material/Button";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const TestWhiteList = () => {
    const project = useSelector(state => state.session.project);
    const permissions = useSelector(state => state.permissions.value);
    const [data, setData] = useState([]);
    const [addWLDialog, setAddWLDialog] = useState(false);
    const [newNick, setNewNick] = useState("");
    const [newSteamID, setNewSteamID] = useState("");
    const getData = async () => {
        if(!localStorage.access_token){
            localStorage.clear();
            window.location.href="/";
        }
        else {
            setData(await Api(`servers/get-whitelist-testserver/${project}`));
        }
    }
    useEffect(() => {
        getData();
    },[project]);

    const addWL = () => {
        postApi(`servers/add-whitelist-testserver/${project}`,
            {steam_id: newSteamID, nickname: newNick, admin_nick: localStorage.getItem("myid")})
            .then(()=>{setAddWLDialog(false); getData()})
    }

    const deleteFromWL = (steamid) => {
        postApi(`/servers/delete-whitelist-testserver/${project}/${steamid}`).then(()=>{setAddWLDialog(false); getData()});
    }

    return <Paper sx={{ width: '100%', overflow: 'hidden', p:1 }}>
        <Typography variant={'h5'} sx={{p:2}}>Управление белым списком тестового сервера: {project.toUpperCase()}</Typography>
        {(permissions.indexOf("edit_whitelist_testserver") > -1) &&
        <Box  sx={{ flexGrow: 0, p:2 }}>
            <Button variant={'outlined'} color={'success'} sx={{mr:2}} onClick={()=>{setAddWLDialog(true)}}>Добавить разрешение</Button>
        </Box>
        }
        {(permissions.indexOf("edit_whitelist_testserver") > -1) &&
            <Box sx={{display: 'flex', width: '100%', minHeight: '80vh'}} component={'div'}>
                        <TableContainer sx={{ maxHeight: 'calc(90vh - 80px)'}}>
                            <Table stickyHeader aria-label="sticky table" size={"small"}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Никнейм</TableCell>
                                        <TableCell>SteamID</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((i,e) =>
                                        <StyledTableRow key={`wl_elem_${e}`}>
                                            <TableCell>{i.nickname}</TableCell>
                                            <TableCell>{i.steam_id}</TableCell>
                                            <TableCell><IconButton onClick = {()=>deleteFromWL(i.steam_id)} color={'red'}><DeleteOutline/></IconButton></TableCell>
                                        </StyledTableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
            </Box>
        }
        {(permissions.indexOf("edit_whitelist_testserver") === -1) &&
            <Box sx={{display: 'flex', width: '100%'}} component={'div'}>
                <Typography color={'error'}>У вас нет прав для редактирования белого списка тестовых серверов!</Typography>
            </Box>
        }
        {(permissions.indexOf("edit_whitelist_testserver") > -1) &&
        <Dialog
            open={addWLDialog}
            onClose={()=>{setAddWLDialog(false)}}
            aria-labelledby="comment-dialog-title"
            aria-describedby="comment-dialog-description"
        >
            <DialogTitle id="comment-dialog-title">
                {"Добавление нового участника в белый список тестового сервера "+project.toUpperCase()}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="comment-dialog-description">
                    <TextField value={newSteamID} fullWidth sx={{mt: 2}} placeholder={'STEAM_0:X:XXXXXXX'}
                               onChange={(e)=>{setNewSteamID(e.target.value)}} label='STEAM_ID'/>
                    <TextField value={newNick} fullWidth sx={{mt: 2}} placeholder={'Никнейм'}
                               onChange={(e)=>{setNewNick(e.target.value)}} label='Никнейм'/>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={()=>{setAddWLDialog(false)}} color={'info'} variant={'contained'} autoFocus>Я передумал</Button>
                <Button onClick={addWL} color={'success'} variant={'contained'}>Добавить</Button>
            </DialogActions>
        </Dialog>
        }
    </Paper>
}

export default TestWhiteList;